import React from "react";
import { Box, IconButton } from "@mui/material";
import { MuiDatePicker } from "./muiDatepicker";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import dayjs from "dayjs";

interface CompactDatePickerProps {
    label?: string;
    value: Date | null;
    onChange: (val: Date | null) => void;
    sx?: React.CSSProperties;
}

const CompactDatePicker: React.FC<CompactDatePickerProps> = ({ label, value, onChange, sx }) => {
    const handlePrevDay = () => {
        if (value) {
            const prevDay = dayjs(value).subtract(1, "day").toDate();
            onChange(prevDay);
        }
    };

    const handleNextDay = () => {
        if (value) {
            const nextDay = dayjs(value).add(1, "day").toDate();
            onChange(nextDay);
        }
    };

    return (
        <Box display="flex" alignItems="center" sx={{ ...sx }}>
            <MuiDatePicker
                label={label}
                value={value}
                onChange={onChange}
                extraProps={{ small: true }}
            />
            <IconButton onClick={handlePrevDay}>
                <ArrowBack />
            </IconButton>
            <IconButton onClick={handleNextDay}>
                <ArrowForward />
            </IconButton>
        </Box>
    );
};

export default CompactDatePicker;
